import script from "./OutboxPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./OutboxPanel.vue?vue&type=script&setup=true&lang=js"

import "./OutboxPanel.vue?vue&type=style&index=0&id=2043d2ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2043d2ca"]])

export default __exports__